import camelCase from 'lodash/camelCase';

/**
 * Пустой объект
 * @type {Object}
 */
export var emptyObject = Object.freeze(Object.create(null));

/**
 * Возвращает новый объект у которого имена свойств
 * начинаются с маленькой буквы
 * @param {Object} object
 * @return {Object}
 */
export var decapitalizePropsNames = function decapitalizePropsNames() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(object).reduce(function (aux, key) {
        aux[camelCase(key)] = object[key];

        return aux;
    }, {});
};

/**
 * Возвращает значения из объекта
 * @param {Object} object
 * @return {Array}
 */
export var values = function values() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(object).map(function (key) {
        return object[key];
    });
};

/**
 * Object.entries() возвращает массив, элементами
 * которого являются массивы, соответсвующие
 * перечисляемому свойству пары [key, value],
 * найденной прямо в object. Порядок свойств
 * тот же, что и при прохождении циклом по 
 * свойствам объекта вручную.
 * @param {Object} object
 * @return {Array<Array>}
 */
export var entries = function entries() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(object).map(function (key) {
        return [key, object[key]];
    });
};

/**
 * Удалить ключ из объекта. Если ключа в объекте нет
 * то будет возвращен старый объект
 * @param {Object} object
 * @param {String} key
 * @return {Object}
 */
export var removeKey = function removeKey() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = arguments[1];

    if (!(key in object)) {
        return object;
    }

    return Object.keys(object).reduce(function (aux, currentKey) {
        if (currentKey !== key) {
            aux[currentKey] = object[currentKey];
        }

        return aux;
    }, {});
};